import React from 'react';
import './Footer.scss'

const Footer = () => {
  return (
    <footer className='footer'>
      <p>© NEW DAY MENTAL HEALTH COUNSELING SERVICES PLLC</p>
    </footer>
  );
};

export default Footer;